import { useCallback } from 'react';

export function useMutedCallback(callback: () => unknown) {
  return useCallback(() => {
    callback();
  }, [callback]);
}
